module.exports = __webpack_public_path__ + "media/images/location-title-78b6fb4b4d37e0e7a9fbe3e67a8b3fbd.jpg";